//import Libraries
import React from 'react'

//import Components
import Language from '../../language/language.json';

//import Style classes
import './Footer.css';


const footer = (props) => {
    const content = [
        Language.location[0].address[props.lang]+"\n",
        Language.location.map((obj, idx)=>{
            return <a href={idx==0 ? "tel:+8215885362":"tel:+82555849058"} title="모바일 환경에서만 전화로 연결됩니다." key={idx}>{obj.name[props.lang]+" : "+obj.telephone+"\n"}</a>
        })
    ];

    const sitemapContent = 
        <table>
            <tbody>
            {Language.newNav.map((obj, idx)=>{
                    return (
                        <tr key={idx}>
                            <th onClick={()=>window.location.href=obj.link}>{obj.name[props.lang]}</th>
                            {obj.subMenu ? obj.subMenu.map((o, i)=> <td key={i} onClick={()=>window.location.href=o.link}>{o.name[props.lang]}</td>): null}
                        </tr>
                    )
                })}
            </tbody>
        </table>

    const sitemap = {
        title: {
            "en": "Sitemap",
            "ko": "사이트맵"
        }
    }
    return(
        <div className='Footer'>
            <div className="Info">
                <h3>{Language.footer.info.title[props.lang]}</h3>
                <p>{content}</p>
                <p className="Rights">{Language.footer.info.copyright[props.lang]}</p>
            </div>
            <div className="Line"/>
            <div className="Sitemap">
                <h3>{sitemap.title[props.lang]}</h3>
                {sitemapContent}
            </div>
        </div>
    );
}

export default footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js